import RoutesArmes from './armes/routes';
import RoutesMunitions from './munitions/routes';
import { initSubRoutes } from '../../../utils/router';
import RoutesHistorique from './historique/routes';

const RoutesRatelier = initSubRoutes({
    route: '/ratelier',
    subroutes: {
        armes: RoutesArmes,
        munitions: RoutesMunitions,
        historique: RoutesHistorique,
    },
    nom: 'Ratelier numérique',
});

export default RoutesRatelier;
